import React, { Component } from 'react'
import { Player, BigPlayButton, ControlBar, PlayToggle, CurrentTimeDisplay, TimeDivider, VolumeMenuButton } from 'video-react'
import './styles/scss/video-react.scss'
import './videoplayer.scss'

class VideoPlayer extends Component {
  render () {
    return (
      <div className='embedded-video'>
        <Player poster={this.props.poster}>
          <ControlBar autoHide={this.props.autoHide} autoHideTime={this.props.autoHideTime} >
            <PlayToggle />
            <CurrentTimeDisplay order={4.1} />
            <TimeDivider order={4.2} />
            <VolumeMenuButton disabled={this.props.hideVolume} />
          </ControlBar>
          <BigPlayButton position={this.props.position} />
          <source src={this.props.src} />
        </Player>
      </div>
    )
  }
}
export default VideoPlayer



// WEBPACK FOOTER //
// ./src/app/shared/components/VideoPlayer/index.js